import React, { FC } from 'react';
import { PaletteMode, useTheme } from '@mui/material';
import './Status.styles.scss';

type VariantType = 'default' | 'success' | 'error' | 'warning' | 'info' | 'muted' | 'danger' | 'pending';

interface Props {
  title?: string;
  variant?: VariantType;
  size?: 'small' | 'medium' | 'large';
}

export const Status: FC<Props> = ({ title, variant = 'default', size = 'small' }) => {
  const theme = useTheme();
  const backgroundColor = getBackgroundColor(variant, theme.palette.mode);

  return (
    <span className="d-inline-flex align-items-baseline">
      <span className={`status ${size} d-inline-block`} style={{ backgroundColor }} />
      {title}
    </span>
  );
};

const getBackgroundColor = (variant: VariantType, mode: PaletteMode): string => {
  const isLightMode = mode === 'light';

  switch (variant) {
    case 'success':
      return isLightMode ? '#5A8F17' : '#A4CF55';
    case 'error':
      return isLightMode ? '#E74536' : '#DB7271';
    case 'info':
      return isLightMode ? '#6384A1' : '#AEC3D7';
    case 'warning':
      return isLightMode ? '#E1BB35' : '#EAC645';
    case 'danger':
      return isLightMode ? '#e48f00' : '#ffe1ac';
    case 'pending':
      return isLightMode ? '#1e8484' : '#c3ffff';
    case 'default':
    default:
      return '#B4B9BE';
  }
};
